import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { GraduationCap, ArrowRight } from '@phosphor-icons/react';

import COLORS from '../../util/constants/colors';
import { openTutorialMenu as openTutorialMenuAction } from '../../actions/tutorial';
import captureTutorialAnalytics from './tutorialAnalytics';

/**
 * Inline Getting Started entry point for the app-wide Learn Medsender checklist.
 */
export const GuideTutorialLinkBase = ({ impersonating, openTutorialMenu }) => {
  const open = () => {
    captureTutorialAnalytics(impersonating, 'tutorial_menu_opened', { source: 'guide_getting_started' });
    openTutorialMenu();
  };

  return (
    <button
      type="button"
      className="guide-tutorial-link"
      onClick={open}
    >
      <span className="guide-tutorial-link__icon" aria-hidden="true">
        <GraduationCap size={24} weight="fill" color={COLORS.PURPLE_PRIMARY_LITE} />
      </span>
      <span className="guide-tutorial-link__copy">
        <span className="guide-tutorial-link__label">Open Learn Medsender</span>
        <span className="guide-tutorial-link__description">
          Short, hands-on walkthroughs for the everyday Medsender workflows.
        </span>
      </span>
      <ArrowRight size={20} weight="bold" aria-hidden="true" />
    </button>
  );
};

GuideTutorialLinkBase.defaultProps = {
  impersonating: false,
  openTutorialMenu: () => {},
};

GuideTutorialLinkBase.propTypes = {
  impersonating: PropTypes.bool,
  openTutorialMenu: PropTypes.func,
};

export default connect((state) => ({
  impersonating: !!state.auth.impersonating,
}), {
  openTutorialMenu: openTutorialMenuAction,
})(GuideTutorialLinkBase);
